import script from "./Locale.vue?vue&type=script&setup=true&lang=ts"
export * from "./Locale.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__